import objectAddress from '@/model/address';
import objectUser from '@/model/user';
import enumHelper from '../utilities/enumHelper';
const cartObject = {
  locationId:null,
  newOrder: null,
  card_id: null,
  save_card: false,
  card: null,
  status: enumHelper.status.PREPARED,
  user: objectUser,
  order: [],
  orderType: enumHelper.orderType.Delivery, //Delivery , PickUp , Table
  total: 0,
  comment: "",
  driver_instructions: "",
  delivery_fee: 0,
  orderTotal: 0,
  coupon_result: null,
  coupon_error: null,
  coupon: "",
  pickUp: {
    //---- ASAP / Later
    type: enumHelper.PickupTime.ASAP,
    date: null,
    time: null,
  },
  address: objectAddress,
  payment_type: null,
  table: null,
  payment_intent: null,
  headers : null , // received stripe headers from the api
  step: enumHelper.steps.STEP01,
  service_charge: 0,
  bag_charge:0,
  postCode: null,
};
export default Object(cartObject)